export default __webpack_public_path__ + "static/media/tabebuya-3.27d2ec80.JPG";